import { ChangeEvent, forwardRef, Ref } from 'react';

import { InputBaseComponentProps } from '@mui/material';
import { formatCNPJInput } from 'src/utils/document';

interface CNPJFormatProps extends InputBaseComponentProps {
  inputRef?: Ref<HTMLInputElement>;
  ownerState?: unknown;
}

function assignRef(
  ref: Ref<HTMLInputElement> | undefined,
  value: HTMLInputElement | null,
) {
  if (typeof ref === 'function') {
    ref(value);
    return;
  }
  if (ref) {
    (ref as { current: HTMLInputElement | null }).current = value;
  }
}

export const CNPJ_FIELD_INPUT_PROPS = {
  inputMode: 'text',
  autoCapitalize: 'characters',
} as const;

const CNPJFormat = forwardRef<HTMLInputElement, CNPJFormatProps>(
  function CNPJFormat(props, ref) {
    const { inputRef, onChange, name, value, ownerState, ...other } = props;

    return (
      <input
        {...other}
        type="text"
        inputMode="text"
        autoCapitalize="characters"
        autoCorrect="off"
        spellCheck={false}
        name={name}
        value={formatCNPJInput(value)}
        ref={(node) => {
          assignRef(ref, node);
          assignRef(inputRef, node);
        }}
        onChange={(event: ChangeEvent<HTMLInputElement>) => {
          onChange?.({
            ...event,
            target: {
              name: name ?? event.target.name,
              value: formatCNPJInput(event.target.value),
            },
          } as ChangeEvent<HTMLInputElement>);
        }}
      />
    );
  },
);

export default CNPJFormat;
